export class CreateGetParamHelper {
    public static createGetParam(object : any) {
        let string = JSON.stringify(object);
        string=string.replace(/{/g, "");
        string=string.replace(/}/g, "");
        string=string.replace(/:/g, "=")
        string=string.replace(/,/g, "&");
        string=string.replace(/"/g, "");
        return  "?" + string;

        //ie11で動かない
        // const queryString = require('query-string');
        // return "?" + queryString.stringify(object)

        
    }

    public static jsonToQueryString(json) {
        return '?' + 
            Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    }
}